import React from "react";
import "./AiFeatureSection.css";

const AiFeatureSection = ({
	badgeText = "最新の生成AIを活用！",
	titleLead = "プログラミング学習を",
	titleEmphasis = "革新的に効率化",
	bullets = [
		{ icon: "code", text: "プログラミングを自動化" },
		{ icon: "bolt", text: "作業を自動化" },
	],
	subcopy = "AIがサポートするから、未経験でも安心してスタートできます",
	onPrimary = () => {
		window.location.href = "/admission";
	},   // 「AI学習を体験」
	onSecondary = () => {
		window.open("https://forms.gle/UJ3r8wwzSBaRZ6Mj6", "_blank");
	}, // 「詳しく見る」
}) => {
	return (
		<div className="aiFeature" aria-labelledby="aiFeature-title">
			<div className="aiFeature__inner">

				{/* 左カラム */}
				<div className="aiFeature__left">
					{/* バッジ */}
					<div className="aiFeature__badge" role="note" aria-label={badgeText}>
						<span className="aiFeature__badgeIcon" aria-hidden="true">
							{/* 小さなAIチップ風アイコン */}
							<svg viewBox="0 0 24 24" width="16" height="16">
								<path fill="currentColor" d="M9 3h6v2h2v2h2v6h-2v2h-2v2H9v-2H7v-2H5V7h2V5h2V3Zm0 4v10h6V7H9Z"/>
							</svg>
						</span>
						{badgeText}
					</div>

					{/* 見出し */}
					<h2 id="aiFeature-title" className="aiFeature__title">
						{titleLead} <span className="aiFeature__em">{titleEmphasis}</span>
					</h2>

					{/* 箇条書き（コード/稲妻アイコン） */}
					<ul className="aiFeature__bullets">
						{bullets.map((b, i) => (
							<li key={i} className="aiFeature__bullet">
								<span className={`aiFeature__icon aiFeature__icon--${b.icon}`} aria-hidden="true">
									{b.icon === "code" ? (
										<svg viewBox="0 0 24 24" width="18" height="18">
											<path fill="currentColor" d="M8.59 16.59L4 12l4.59-4.59L10 8.82 6.83 12 10 15.18l-1.41 1.41Zm6.82 0L14 15.18 17.17 12 14 8.82l1.41-1.41L20 12l-4.59 4.59Z"/>
										</svg>
									) : (
										<svg viewBox="0 0 24 24" width="18" height="18">
											<path fill="currentColor" d="M13 2L3 14h7l-1 8 10-12h-7l1-8Z"/>
										</svg>
									)}
								</span>
								{b.text}
							</li>
						))}
					</ul>

					<p className="aiFeature__sub">{subcopy}</p>
				</div>

				{/* 右カラム：ボタン */}
				<div className="aiFeature__right">
					<button
						type="button"
						className="aiBtn aiBtn--primary"
						onClick={onPrimary}
						aria-label="AI学習を体験"
					>
						AI学習を習得
					</button>
					<button
						type="button"
						className="aiBtn aiBtn--outline"
						onClick={onSecondary}
						aria-label="詳しく見る"
					>
						資料を請求
					</button>
				</div>

			</div>
		</div>
	);
};

export default AiFeatureSection;